import { CommonModule } from '@angular/common';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DesignAngularKitModule,
  ItNotificationService,
  ItUploadDragDropComponent,
} from 'design-angular-kit';
import {
  catchError,
  finalize,
  map,
  of,
  skipWhile,
  Subscription,
  tap
} from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-new-attach-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './new-attach-modal.component.html',
  styleUrl: './new-attach-modal.component.scss',
})
export class NewAttachModalComponent implements OnDestroy {
  @ViewChild('uploadDragDropComponent')
  uploadDragDropComponent!: ItUploadDragDropComponent;
  @Input() transitionId!: string;
  @Output() newAttach = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  private uploadSub?: Subscription;

  attachTypes: any[] = [];
  selectedTypeAttachId: number | null = null;

  constructor(
    private http: HttpClient,
    private notification: ItNotificationService
  ) {}

  ngOnInit(): void {
    this.loadNoteTypes();
  }

  loadNoteTypes(): void {
    this.http
      .get<any[]>(`${environment.beServiceUrl}/v1/attachment/types`)
      .subscribe((data) => {
        this.attachTypes = data.filter(t=>t.selectable);
      });
  }

  onDragUploadStart(event: any): void {
    const url =
      environment.beServiceUrl +
      `/v1/attachment/insert?transitionUuid=${this.transitionId}&signed=false&typeId=${this.selectedTypeAttachId}`;

    const fileToUpload = event;
    fileToUpload.progress = 1;
    fileToUpload.error = undefined;
    fileToUpload.removable = false;

    const formData = new FormData();
    formData.append('file', fileToUpload);

    this.http
      .post<any>(url, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        tap((event) => {
          if (event.type === HttpEventType.UploadProgress) {
            fileToUpload.progress = Math.round(
              (event.loaded / (event.total || 1)) * 100
            );
          }
        }),
        skipWhile((event) => event.type !== HttpEventType.Response),
        map((event) => (event as HttpResponse<any>).body),
        tap(() => {
          fileToUpload.progress = 100;
        }),
        catchError((error) => {
          fileToUpload.progress = undefined;
          fileToUpload.removable = true;
          fileToUpload.error = true;
          fileToUpload.tooltip = error.message;
          return of(null);
        }),
        finalize(() => {
          if (
            !fileToUpload.error &&
            fileToUpload.progress &&
            fileToUpload.progress < 100
          ) {
            fileToUpload.progress = undefined;
            fileToUpload.removable = true;
            fileToUpload.error = true;
            fileToUpload.tooltip = 'Incomplete upload error';
          }
        })
      )
      .subscribe((result) => {
        if (result !== null) {
          this.notification.success('Il file è stato caricato con successo.');
          this.newAttach.emit();
        }
        this.uploadDragDropComponent.reset();
        this.reset();
      });
  }

  reset() {
    this.selectedTypeAttachId = null;
  }

  // confirm(): void {
  //   const request = {
  //     transitionId: this.transitionId,
  //     typeId: this.selectedTypeAttachId,
  //     insertUserCode: this.authService.userInfo.username,
  //   };
  //   this.noteService.insertNote(request).subscribe(
  //     (response) => {
  //       this.newAttach.emit();
  //       this.reset();
  //     },
  //     (err) => {
  //       this.notification.error(
  //         'Si è verificato un problema durante il salvataggio della nota.'
  //       );
  //     }
  //   );
  // }

  cancel(): void {
    this.reset();
    this.cancelled.emit();
  }

  ngOnDestroy(): void {
    this.uploadSub?.unsubscribe();
  }
}
